import { styled } from 'styled-components';

import checked from 'src/resources/checked.svg';
import { colorNeutral400, colorNeutral700 } from 'src/styles/colors';
import { focus } from 'src/styles/mixins';

export const StyledInput = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  min-width: 18px;
  min-height: 18px;
  border: 2px solid ${colorNeutral700};
  border-radius: 1px;
  cursor: pointer;
  box-sizing: border-box;

  &:checked {
    background: url('${checked}') no-repeat ${colorNeutral700};
    background-size: contain;
  }

  ${focus};

  &:focus-visible {
    border-radius: 1px;
  }
`;

export const StyledContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    ${StyledInput} {
      border-color: ${colorNeutral400};

      &:checked {
        background: url('${checked}') ${colorNeutral400};
        background-size: cover;
      }
    }
  }
`;
